import Vue from 'vue'
import Vuex from 'vuex'
import authModule from '@/store/modules/auth'
import * as customerModule from '@/store/modules/customer'
import * as businessModule from '@/store/modules/business'
import * as categoryModule from '@/store/modules/category'
import * as itemModule from '@/store/modules/item'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		customerModule,
		authModule,
		businessModule,
		categoryModule,
		itemModule
	},
	state: {
		gridCategories: 6,
		showFeatured: true,
		collectionFound: true,
		bussinessId: '',
		bussiness: {},
		category: [],
		categories: [],
		featured: [],
		items: [],
		loaded: false,
		showSnack: false,
		alert: {
			type: 'success',
			show: false,
			message: '',
			color: 'primary'
		},
	},
	mutations: {
		SET_CATEGORY(state, payload) {
			state.category = payload;
		},
		SET_GRID_CATEGORIES(state, payload) {
			state.gridCategories = payload;
		},
		SET_SHOW_FEATURED(state, payload) {
			state.showFeatured = payload;
		},
		SET_COLLECTION_FOUND(state, payload) {
			state.collectionFound = payload;
		},
		SET_BUSSINESS(state, payload) {
			state.bussiness = payload;
		},
		SET_BUSSINESS_ID(state, payload) {
			state.bussinessId = payload;
		},
		SET_CATEGORIES(state, payload) {
			state.categories = payload;
		},
		SET_FEATURED(state, payload) {
			state.categories = payload;
		},
		SET_LOADED(state, payload) {
			state.loaded = payload;
		},
		SET_SHOWSNACK: (state, value) => {
			state.showSnack = value;
		},
		SET_ALERT_MESSAGE: (state, data) => {
			state.alert.type = data.type;
			state.alert.show = data.show;
			state.alert.message = data.message;
			state.alert.color = data.color;
			setTimeout(() => {
				state.alert.type = 'success';
				state.alert.show = false;
				state.alert.message = '';
				state.alert.color = 'primary';
			}, data.timeout);
		}
	},
	actions: {
		changeGridCategories({ commit }, value) {
			commit("SET_GRID_CATEGORIES", value);
		},
		changeShowFeatured({ commit }, value) {
			commit("SET_SHOW_FEATURED", value);
		},
		toggleCollectionFound({ commit }, value) {
			commit('SET_COLLECTION_FOUND', value)
		},
		setBussinessId({ commit }, value) {
			commit('SET_BUSSINESS_ID', value)
		},
		setBussiness({ commit }, value) {
			commit('SET_BUSSINESS', value)
		},
		setCategories({ commit }, value) {
			commit('SET_CATEGORIES', value)
		},
		setCategory({ commit }, value) {
			commit('SET_CATEGORY', value)
		},
		setFeatured({ commit }, value) {
			commit('SET_FEATURED', value)
		},
		setLoaded({ commit }, value) {
			commit('SET_LOADED', value)
		},
		setShowSnackbar({ commit }, value) {
			commit('SET_SHOWSNACK', value)
		},

	},

})
